import $ from "jquery";


class FactfinderPagination {

	constructor( paginationEl ) {
		this.paginationEl = paginationEl;

		this.paginationEl.addEventListener( 'click', ( ev ) => {

			if ( ev.target.matches( '.prev' ) ) {
				ev.preventDefault();
				const {previousLink} = this.paging;
				this.paginationEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams: previousLink.searchParams } } ) );
			} else if ( ev.target.matches( '.next' ) ) {
				ev.preventDefault();
				const {nextLink} = this.paging;
				this.paginationEl.dispatchEvent( new CustomEvent( 'change.ff', { bubbles: true, detail: { searchParams: nextLink.searchParams } } ) );
			}
		} )
	}

	async update( {paging} ) {
		this.paging = paging;

		const innerEl = document.createElement( 'div' );
		innerEl.classList.add( 'mdl_pagination_list__inner' );

		let innerHTML = '';
		if ( paging.previousLink ) {
			const prevParams = new URLSearchParams( $.param( paging.previousLink.searchParams ) );
			innerHTML += `<a class="prev link" title="Seite ${paging.previousLink.number}" href="/shop-suche/?${prevParams.toString()}" >Prev</a>`;
		}

		innerHTML += `<span class="pagenum">Seite ${paging.currentPage} von ${paging.pageCount}</span>`;

		if ( paging.nextLink ) {
			const nextParams = new URLSearchParams( $.param( paging.nextLink.searchParams ) );
			innerHTML += `<a class="next link" title="Seite ${paging.nextLink.number}" href="/shop-suche/?${nextParams.toString()}" >Next</a>`;
		}

		innerEl.innerHTML = innerHTML;
		this.paginationEl.replaceChildren( innerEl );
	}
}

export default FactfinderPagination;
